export enum ListItemType {
  BucketList = "bucket_list",
  Interest = "interest",
  Languages = "languages"
}
